<script>
import { includes as _includes, startsWith } from 'lodash-es'
import { mapState, mapMutations, mapActions } from 'vuex'

import { namespace as gnbNamespace, types as gnbTypes } from '../../../store/modules/gnb-store'
import { namespace as commonNamespace, types as commonTypes } from '../../../store/modules/common-store'
import { namespace, types } from '../../../store/modules/marketplace-hierarchy-store'

const visibleEvaluator = new Function(
  'envs',
  'jp',
  'mobile',
  'expression',
  `return eval(expression)`
)

export default {
  props: {
    gnbMenus: {
      type: Array,
      required: true
    }
  },
  created() {
    this.getMarketPlaceGnbHierarchy()
  },
  methods: {
    ...mapMutations(gnbNamespace, [gnbTypes.SET_HOVER_GNB, gnbTypes.SET_HOVER_CUSTOM_MENU]),
    ...mapActions(namespace, [types.GET_MARKETPLACE_GNB_HIERARCHY]),
    hoverCustomMenu(menu, hover) {
      this.setHoverCustomMenu({
        hover,
        menu
      })
    },
    addSubMenuClass({addClass = false}) {
      return addClass
    },
    isGnbMenuShow(gnbMenu) {
      if (!gnbMenu.visible) {
        return true
      }
      return visibleEvaluator(envs, this.isJp, this.isMobile, gnbMenu.visible)
    },
    isGnbSubMenuShow(gnbMenu) {
      if (gnbMenu.subMenuVisible) {
        return visibleEvaluator(envs, this.isJp, this.isMobile, gnbMenu.subMenuVisible)
          && (this.exist(gnbMenu.subMenus) || this.exist(gnbMenu.subMenuComponent))
      }
      return this.exist(gnbMenu.subMenus) || this.exist(gnbMenu.subMenuComponent)
    },
    isGnbSubMenuPartShow(subMenu) {
      if (!subMenu.visible) {
        return true
      }
      return visibleEvaluator(envs, this.isJp, this.isMobile, subMenu.visible)
    },
    addCountryIfHomepageUrl(url) {
      const homepageBase = domain['homepage'] || location.origin
      if (startsWith(url, homepageBase)) {
        const homepageWithCountry = `${homepageBase}${this.countryPath}`
        return url.replace(homepageBase, homepageWithCountry)
      } else if (mode === 'homepage' && startsWith(url, '/')) {
        return `${this.countryPath}${url}`
      }
      return url
    }
  }
}
</script>
